import { initializeDB } from '../config/db';
import { VENDOR_STORE, URL } from '../config/constants';
import axios from 'axios';

const vendorService = {
    /**
     * Синхронизация вендоров с сервера
     */
    async syncVendors() {
        try {
            console.log('Starting vendor sync...');
            
            // Получаем данные с сервера
            const response = await axios.get(`${URL}/vendors`);
            const vendors = response.data;
            
            console.log(`Received ${vendors.length} vendors from server`);
            
            // Открываем базу данных
            const db = await initializeDB();
            const tx = db.transaction(VENDOR_STORE, 'readwrite');
            const store = tx.objectStore(VENDOR_STORE);
            
            // Очищаем старые данные
            await store.clear();
            
            // Добавляем новые данные
            for (const vendor of vendors) {
                await store.add(vendor);
            }
            
            await tx.done;
            
            console.log('Vendor sync completed successfully');
            return vendors;
        } catch (error) {
            console.error('Error syncing vendors:', error);
            throw error;
        }
    },
    
    /**
     * Получение всех вендоров из локальной БД
     */
    async getVendors() {
        try {
            const db = await initializeDB();
            const tx = db.transaction(VENDOR_STORE, 'readonly');
            const store = tx.objectStore(VENDOR_STORE);
            const vendors = await store.getAll();
            
            return vendors;
        } catch (error) {
            console.error('Error getting vendors from IndexedDB:', error);
            throw error;
        }
    },
    
    /**
     * Получение вендора по ID
     */
    async getVendorById(id) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(VENDOR_STORE, 'readonly');
            const store = tx.objectStore(VENDOR_STORE);
            const vendor = await store.get(id);
            
            return vendor;
        } catch (error) {
            console.error('Error getting vendor by ID:', error);
            throw error;
        }
    },
    
    /**
     * Поиск вендоров по имени
     */
    async searchVendors(searchTerm) {
        try {
            const vendors = await this.getVendors();
            
            if (!searchTerm) {
                return vendors;
            }
            
            const term = searchTerm.toLowerCase();
            
            return vendors.filter(vendor => 
                (vendor.vendor && vendor.vendor.toLowerCase().includes(term)) ||
                (vendor.description && vendor.description.toLowerCase().includes(term)) ||
                (vendor.contact && vendor.contact.toLowerCase().includes(term))
            );
        } catch (error) {
            console.error('Error searching vendors:', error);
            throw error;
        }
    }
};

export default vendorService;